import { useEffect, useState } from "react";

export const getDrill = () => {
  try { return JSON.parse(localStorage.getItem("drill_school") || "null"); }
  catch { return null; }
};

export const setDrill = (d) => {
  if (d && d.id) localStorage.setItem("drill_school", JSON.stringify({ id: d.id, name: d.name || "" }));
  else localStorage.removeItem("drill_school");
  window.dispatchEvent(new Event("drill-change"));
};

export const useDrill = () => {
  const [d, setD] = useState(getDrill());
  useEffect(() => {
    const h = () => setD(getDrill());
    window.addEventListener("drill-change", h);
    return () => window.removeEventListener("drill-change", h);
  }, []);
  return d;
};
